import React, { createContext } from "react"
import { WebRole } from "../../../Utils/Entities"

export const WebRoleContext = createContext<WebRole[]>([])
